import DgTooltip from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgTooltip.install = function (Vue) {
  Vue.component(DgTooltip.name, DgTooltip)
}
export default DgTooltip

export { DgTooltip }